<template>
  <div>
    <h1>Gutschein einlösen</h1>

    <div v-if="!response">
      Gutscheincode "<strong>{{ couponcode }}</strong>" wird eingelöst…
    </div>
    <div v-if="response">
      <div v-html="response"></div>
      Du wirst in wenigen Sekunden zur <router-link tag="a" :to="{ name: 'Startseite' }" class="text-black">Startseite</router-link> geleitet…
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import axios from 'axios'

export default {
  name: 'CouponRedemption',

  data () {
    return {
      couponcode: this.$route.params.code,
      response: null
    }
  },

  computed: {

  },

  watch: {

  },

  created () {
    this.redemption()
  },

  methods: {
    redemption () {
      axios.post(endpoints.redeemCoupon, {
        couponCode: this.couponcode,
        isv3: true
      })
        .then(response => {
          this.response = response.data

          window.setTimeout(() => {
            this.$router.push({ name: 'Startseite' })
          }, 4000)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/home/coupon-redemption.vue